import { useLanguage } from '@/context/LanguageContext';

export default function LegalDocument({ content, testId }) {
  const { lang } = useLanguage();
  const c = content[lang] || content.en;

  return (
    <div data-testid={testId} className="pt-20 bg-[#080B10]">
      <section className="py-20 md:py-24 bg-[#0E131F]/50 border-b border-slate-800/60">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <p className="text-xs md:text-sm uppercase tracking-[0.25em] font-bold text-[#6366F1] mb-4"
             style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            DZent Limited
          </p>
          <h1 data-testid={`${testId}-title`}
              className="text-3xl md:text-4xl lg:text-5xl tracking-tighter font-bold text-white leading-tight mb-4"
              style={{ fontFamily: "'Plus Jakarta Sans', 'Noto Sans TC', sans-serif" }}>
            {c.title}
          </h1>
          <p className="text-sm text-white/60">{c.updated}</p>
        </div>
      </section>

      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <p className="text-base text-[#94A3B8] leading-relaxed mb-12"
             style={{ fontFamily: "'Manrope', 'Noto Sans TC', sans-serif" }}>
            {c.intro}
          </p>
          {c.sections.map((section) => (
            <section key={section.heading} className="mb-10">
              <h2 className="text-xl md:text-2xl tracking-tight font-bold text-[#F8FAFC] mb-4"
                  style={{ fontFamily: "'Plus Jakarta Sans', 'Noto Sans TC', sans-serif" }}>
                {section.heading}
              </h2>
              {section.paragraphs.map((p) => (
                <p key={p} className="text-base text-[#94A3B8] leading-relaxed mb-3"
                   style={{ fontFamily: "'Manrope', 'Noto Sans TC', sans-serif" }}>
                  {p}
                </p>
              ))}
              {section.items && (
                <ul className="list-disc pl-6 space-y-2 mt-3">
                  {section.items.map((item) => (
                    <li key={item} className="text-base text-[#94A3B8] leading-relaxed"
                        style={{ fontFamily: "'Manrope', 'Noto Sans TC', sans-serif" }}>
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </article>
    </div>
  );
}
